//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import draggable from "vuedraggable";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQEmptySearch from "@/components/Generics/AQEmptySearch/AQEmptySearch.vue";
import deleteHoverNoBg from "@/assets/images/Buttons/deleteHoverNoBg.svg";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";

function generateSanitizedCamelIshCase(str) {
    // sanitize: removes non alphanumeric chars except "_"
    // camel-ish case: unlike camel case this function preserves uppercase letters inside words
    str = str.replace(/[^a-zA-Z0-9 _]/g, "");
    return str.split(" ").reduce((acc, word, index) => {
        if (!index) return `${acc}${(word[0] && word[0].toLowerCase()) || ""}${word.slice(1)}`;
        return `${acc}${(word[0] && word[0].toUpperCase()) || ""}${word.slice(1)}`;
    }, "");
}

export default {
    name: "CreateEntityModalNew",
    components: {
        AQInput,
        AQModal,
        AQCard,
        AQDropdown,
        AQButton,
        draggable,
        AQTooltip,
        AQDialog,
        AQEmptySearch
    },
    data() {
        return {
            entity: {
                name: "",
                code: ""
            },
            showModal: true,
            emptyName: false,
            emptyCode: false,
            wrongPatternErr: false,
            wrongPatternErrCode: false,
            searchAttribute: "",
            name: "",
            code: "",
            type: "",
            draggableColumns: [], 
            deleteIcon: deleteHoverNoBg,
            duplicatedEntityName: false,
            duplicatedEntityCode: false,
            // eslint-disable-next-line no-useless-escape
            validatePatternName: new RegExp(/^[ a-zA-Z0-9_\/\n/-]{1,60}$/),
            validatePatternCode: new RegExp(/^[a-zA-Z0-9_]{1,60}$/),
            counter: 0,
            inputNameKey: 0,
            inputCodeKey: 0,
            showDialog: false,
            typeOpts: [
                {
                    value: "string",
                    label: "String"
                },
                {
                    value: "integer",
                    label: "Integer"
                },
                {
                    value: "decimal",
                    label: "Decimal"
                },
                {
                    value: "datetime",
                    label: "Date-time"
                },
                {
                    value: "date",
                    label: "Date"
                },
                {
                    value: "time",
                    label: "Time"
                },
                {
                    value: "BOOLEAN",
                    label: "Boolean"
                }
            ],
            defaultSource: "string",
            entityList: [],
            idFound: false,
            inputValueChanged: false,
            columnNames: {}
        };
    },
    computed: {
        save() {
            return {
                label: this.$t("admin.usersAndRoles.permissionsModal.saveBtn")
            };
        },
        isError() {
            return this.emptyName || this.wrongPatternErr || this.duplicatedEntityName;
        },
        isErrorCode() {
            return (this.emptyCode && !this.isError) || this.wrongPatternErrCode || this.duplicatedEntityCode;
        },
        errorLabel() {
            let errorMsg;
            if (!this.entity.name) {
                errorMsg = this.$t("globalDataModel.emptyName");
            } else if (this.wrongPatternErr) {
                errorMsg = this.$t("globalDataModel.wrongPattern");
            } else if (this.duplicatedEntityName) {
                errorMsg = this.$t("globalDataModel.duplicateName");
            }
            return errorMsg;
        },
        errorLabelCode() {
            let errorMsgCode;
            if (!this.entity.code) {
                if (this.entity.name) {
                    errorMsgCode = this.$t("globalDataModel.emptyName");
                }
            } else if (this.wrongPatternErrCode) {
                errorMsgCode = this.$t("globalDataModel.wrongPatternCode");
            } else if (this.duplicatedEntityCode) {
                errorMsgCode = this.$t("globalDataModel.duplicateCode");
            }
            return errorMsgCode;
        },
        filteredList() {
            let attributes = [];
            const lowerCaseValue = this.searchAttribute.toLowerCase();
            attributes = this.draggableColumns.filter(column => (column.name || "").toLowerCase().includes(lowerCaseValue)
            || (column.code || "").toLowerCase().includes(lowerCaseValue));
            return attributes;
        },
        nothingToSave() {
            return !this.inputValueChanged;
        }
    },
    watch: {
        "entity.code": {
            handler(newVal) {
                const validatePattern = new RegExp(/^[a-zA-Z0-9_]{1,60}$/);
                this.wrongPatternCode = newVal && !validatePattern.test(newVal);
                this.emptyCode = !newVal && this.entity.name;
                this.wrongPatternErrCode = this.wrongPatternCode;
                this.duplicatedEntityCode = false;
                const foundEntityCode = this.entityList.find(element => element.code === newVal);
                if (foundEntityCode) {
                    this.duplicatedEntityCode = true;
                } else {
                    this.duplicatedEntityCode = false;
                }
                this.inputValueChanged = true;
            }
        },
        nothingToSave: {
            handler(newVal) {
                this.$store.commit("main/setInterfaceDirty", !newVal);
            }
        }
    },
    mounted() {
        this.getEntities().then((entList) => {
            for (let i = 0; i < entList.data.length; i++) {
                this.entityList.push({
                    name: entList.data[i].name,
                    code: entList.data[i].code
                });
            }
        });
    },
    methods: {
        ...mapActions("dataStore", ["addNewEntityDataStore", "getEntityDataStore", "getEntities"]),
        actionsDlg($event) {
            if ($event === "save") {
                this.checkAlphaColValues();
                this.checkDuplicatesColumnsOnSave();
                this.emptyName = !this.entity.name;
                this.emptyCode = !this.entity.code;
                const itemError = this.draggableColumns.find(item => item.error === true) || false;
                const itemErrorCode = this.draggableColumns.find(item => item.errorCode === true) || false;
                if (!this.emptyName && !this.emptyCode && !this.wrongPatternErr && !this.wrongPatternErrCode && !itemError.error
                && !itemErrorCode.errorCode && !this.duplicatedEntityName && !this.duplicatedEntityCode) {
                    const formattedArray = [];
                    for (let i = 0; i < this.draggableColumns.length; i++) {
                        formattedArray.push({
                            code: this.draggableColumns[i].code,
                            name: this.draggableColumns[i].name,
                            type: this.draggableColumns[i].type[0].value
                        });
                    }
                    const payload = {
                        code: this.entity.code,
                        name: this.entity.name,
                        type: "PLATFORM",
                        columns: formattedArray || []
                    };
                    this.addNewEntityDataStore(payload).then(() => {
                        this.$store.commit("main/setInterfaceDirty", false);
                        sessionStorage.setItem("currentDataStoreUser", true);
                        this.showModal = false;
                        this.$toast.showNotify({
                            type: "success",
                            message: this.$t("globalDataModel.entityCreated"),
                            timeout: 500
                        });
                        this.$emit("refreshEntityList", { ev: "created", name: payload.name });
                        this.$emit("input", false);
                    })
                        .catch((err) => {
                            if (err.response.status === 409) {
                                if (err.response.data.entityNameInvalid) {
                                    this.showModal = true;
                                    this.duplicatedEntityName = true;
                                }
                                if (err.response.data.entityCodeInvalid) {
                                    this.showModal = true;
                                    this.duplicatedEntityCode = true;
                                }
                            }
                        });
                } else {
                    this.showModal = true;
                }
            } else if ($event === "close") {
                if (this.entity.name || this.entity.code || this.draggableColumns.length) {
                    this.showDialog = true;
                } else {
                    this.$emit("input", false);
                    this.inputValueChanged = false;
                }
            }
        },
        errorLabelAttribute(item) {
            let errorMsg;
            if (!item.name) {
                errorMsg = this.$t("globalDataModel.emptyName");
            } else if (!this.validatePatternName.test(item.name)) {
                errorMsg = this.$t("globalDataModel.wrongPattern");
            } else if (this.columnNames[item.name].length > 1) {
                errorMsg = this.$t("globalDataModel.duplicateName");
            }
            return errorMsg;
        },
        errorLabelAttributeCode(item) {
            let errorMsg;
            if (!item.code) {
                if (!item.error) {
                    errorMsg = this.$t("globalDataModel.emptyName");
                }
            } else if (!this.validatePatternCode.test(item.code)) {
                errorMsg = this.$t("globalDataModel.wrongPatternCode");
            } else if (this.checkDuplicatedColCode(item)) {
                errorMsg = this.$t("globalDataModel.duplicateCode");
            }
            return errorMsg;
        },
        checkEntityName() {
            // eslint-disable-next-line
            const validatePattern = new RegExp(/^[ a-zA-Z0-9_\/\n/-]{1,60}$/);
            this.wrongPattern = !validatePattern.test(this.entity.name);
            this.emptyName = !this.entity.name;
            this.wrongPatternErr = this.wrongPattern;
            this.duplicatedEntityName = false;
            const foundEntityName = this.entityList.find(element => element.name === this.entity.name);
            if (foundEntityName) {
                this.duplicatedEntityName = true;
            } else {
                this.duplicatedEntityName = false;
            }
            this.inputValueChanged = true;
        },
        checkNameSetCode() {
            this.checkEntityName();
            this.generateEntityCode();
        },
        generateEntityCode() {
            const camelCode = generateSanitizedCamelIshCase(this.entity.name);
            const allCodesSet = this.entityList.reduce(
                (acc, entity) => acc.add(entity.code), new Set()
            );
            let newCode = camelCode;
            let iterator = 0;
            while (allCodesSet.has(newCode)) {
                iterator++;
                newCode = `${camelCode}${iterator}`;
            }
            this.entity.code = newCode;
        },
        checkAlphaColValues() {
            // eslint-disable-next-line no-useless-escape
            for (let i = 0; i < this.draggableColumns.length; i++) {
                if (!this.draggableColumns[i].name) {
                    this.draggableColumns[i].error = true;
                } else if (!this.validatePatternName.test(this.draggableColumns[i].name)) {
                    this.draggableColumns[i].error = true;
                } else if (this.columnNames[this.draggableColumns[i].name].length > 1) {
                    this.draggableColumns[i].error = true;
                } else {
                    this.draggableColumns[i].error = false;
                }
                if (!this.draggableColumns[i].code) {
                    this.draggableColumns[i].errorCode = true;
                } else if (!this.validatePatternCode.test(this.draggableColumns[i].code)) {
                    this.draggableColumns[i].errorCode = true;
                } else if (this.checkDuplicatedColCode(this.draggableColumns[i])) {
                    this.draggableColumns[i].errorCode = true;
                } else {
                    this.draggableColumns[i].errorCode = false;
                }
            }
            this.inputNameKey++;
        },
        scrollToBottom() {
            const { modalContent } = this.$refs;
            if (modalContent) {
                modalContent.scrollTop = modalContent.scrollHeight;
            }
        },
        addCol() {
            this.checkAlphaColValues();
            const found = this.draggableColumns.some(elem => elem.errorCode || elem.error);
            if (!found) {
                const newCol = {
                    name: "",
                    code: "",
                    type: [{ label: "String", value: "string" }]
                };
                this.draggableColumns.push(newCol);
            }
            this.$nextTick(() => {
                this.scrollToBottom();
            });
        },
        deleteAttribute(item) {
            const indexToDelete = this.draggableColumns.findIndex(el => el.name === item.name);
            this.draggableColumns.splice(indexToDelete, 1);
            this.checkAlphaColValues();
        },
        generateAttributeCode(item) {
            const camelCode = generateSanitizedCamelIshCase(item.name);
            const allCodesSet = this.draggableColumns.reduce(
                (acc, attribute) => {
                    if (attribute !== item) {
                        acc.add(attribute.code);
                    }
                    return acc;
                },
                new Set()
            );
            let newCode = camelCode;
            let iterator = 0;
            while (newCode && allCodesSet.has(newCode)) {
                iterator++;
                newCode = `${camelCode}${iterator}`;
            }
            item.code = newCode;
            item.errorCode = false;
        },
        checkAttributeName(item, blur) {
            item.error = false;
            this.checkDuplicatedColName();
            item.error = item.error || !this.validatePatternName.test(item.name) || !item.name;
            if (blur && !item.name) {
                this.inputNameKey++;
            }
            this.inputValueChanged = true;
        },
        checkAttributeNameSetCode(item) {
            this.checkAttributeName(item);
            this.generateAttributeCode(item);
        },
        checkAttributeCode(item, blur) {
            item.errorCode = false;
            item.errorCode = (item.code && (!this.validatePatternCode.test(item.code) || this.checkDuplicatedColCode(item))) || (!item.code && !item.error);
            if (blur && !item.code) {
                this.inputCodeKey++;
            }
            this.inputValueChanged = true;
        },
        checkDuplicatedColCode(item) {
            const codeToReturn = typeof item === "string" ? item : item.code;
            let valToReturn = false;
            const currentIndex = this.draggableColumns.findIndex(elem => JSON.stringify(elem) === JSON.stringify(item));
            for (let i = 0; i < this.draggableColumns.length; i++) {
                if ((i !== currentIndex && codeToReturn === this.draggableColumns[i].code) || codeToReturn === "id") {
                    valToReturn = true;
                    break;
                } else {
                    this.draggableColumns[currentIndex].errorCode = false;
                }
            }
            return valToReturn;
        },
        checkDuplicatedColName() {
            this.columnNames = this.draggableColumns.reduce(
                (acc, col) => {
                    if (!acc[col.name]) {
                        col.error = false;
                        acc[col.name] = [col];
                    } else {
                        if (acc[col.name].length === 1) {
                            acc[col.name][0].error = true;
                        }
                        col.error = true;
                        acc[col.name].push(col);
                    }
                    return acc;
                }, { ID: [{ name: "ID", error: false }] }
            );
        },
        checkDuplicatesColumnsOnSave() {
            for (let i = 0; i < this.draggableColumns.length - 1; i++) {
                for (let j = i + 1; j < this.draggableColumns.length; j++) {
                    if (this.draggableColumns[i].name && this.draggableColumns[j].name) {
                        if (this.draggableColumns[i].name === this.draggableColumns[j].name) {
                            this.draggableColumns[j].error = true;
                        } else {
                            this.draggableColumns[i].error = false;
                        }
                    }
                    if (this.draggableColumns[i].code && this.draggableColumns[j].code) {
                        if (this.draggableColumns[i].code === this.draggableColumns[j].code) {
                            this.draggableColumns[j].errorCode = true;
                        } else {
                            this.draggableColumns[i].error = false;
                        }
                    }
                }
            }
        },
        defaultValMth(val) {
            let returnType = null;
            if (val && val.length) {
                if (typeof val === "object") {
                    returnType = val[0].value;
                } else {
                    returnType = val;
                }
            }
            return returnType;
        },
        wrnAction(action) {
            if (action === "ok") {
                this.showModal = false;
                this.showDialog = false;
                this.inputValueChanged = false;
                this.$emit("input", false);
            }
        },
        searchItems(searchText) {
            if (searchText && searchText.length > 1) {
                if (searchText.includes("ID") || searchText.includes("id")) {
                    this.idFound = true;
                } else {
                    this.idFound = false;
                }
            }
        }
    }

};
